export const SIGN_MESSAGE = "Sign in to BAG Worlds";
export const SIGNED_MESSAGE_HEADER = "X-SIGNED-MESSAGE";
export const LOCAL_STORAGE_KEY = "ExodusTownSignedMessages";
